import { render } from "./NameCharForm.vue?vue&type=template&id=30a81d30&scoped=true&ts=true"
import script from "./NameCharForm.vue?vue&type=script&lang=ts"
export * from "./NameCharForm.vue?vue&type=script&lang=ts"

import "./NameCharForm.vue?vue&type=style&index=0&id=30a81d30&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a81d30"]])

export default __exports__